import styled from 'styled-components';

import { media } from '@theme/mixins';
import colors from '@theme/colors';
import selectArrowDown from '@assets/icons/select-arrow-down.svg';

export const FieldSelect = styled.select`
  font-family: GTAmerica, 'GT America';
  width: 100%;
  height: 64px;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${colors['charcoal']};
  border: ${({ error }) =>
    error ? `solid 2px ${colors['error-red']}` : 'none'};
  border-radius: 0px;
  box-shadow: none;
  padding: 22px 25px;
  background-color: ${colors['white']};
  background-image: url(${selectArrowDown});
  background-size: 24px;
  background-repeat: no-repeat;
  &:focus {
    outline: none;
  }
  &::-ms-expand {
    width: 0;
    height: 0;
  }

  &.ltr {
    background-position: calc(100% - 1em);
  }
  &.rtl {
    background-position: 1em;
  }

  ${media.tabletPortraitUp`
    font-size: 17.5px;
  `};
`;
